import { Injectable } from '@angular/core';
import { GetCategoryRecommendationData } from '@cpak/adp-cpak-bff-service-models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddProductToPakRecommendationsService {
  private switcherValue$ = new BehaviorSubject(false);
  private switcherValueCore$ = new BehaviorSubject(false);
  private switcherIsShown$ = new BehaviorSubject(false);
  private recommendations$ = new BehaviorSubject<GetCategoryRecommendationData | null>(null);

  public setSwitcherValue(value: boolean): void {
    this.switcherValue$.next(value);
  }
  public setCorePakChange(value: boolean): void {
    this.switcherValueCore$.next(value);
  }
  public getCorePakChange(): Observable<boolean> {
    return this.switcherValueCore$.asObservable();
  }
  public setSwitcherIsShown(value: boolean): void {
    this.switcherIsShown$.next(value);
  }

  public setRecommendations(data: GetCategoryRecommendationData | null): void {
    this.recommendations$.next(data);
  }

  public getSwitcherValue(): Observable<boolean> {
    return this.switcherValue$.asObservable();
  }

  public getSwitcherIsShown(): Observable<boolean> {
    return this.switcherIsShown$.asObservable();
  }

  public getRecommendations(): Observable<GetCategoryRecommendationData | null> {
    return this.recommendations$.asObservable();
  }

  public reset(): void {
    this.setSwitcherValue(false);
    this.setSwitcherIsShown(false);
    this.setRecommendations(null);
  }
}
